import { testimoniesEnglish } from 'mocks/testimonies';

export const testimoniesContent = {
  backgroundColor: '#FCFAFA',
  carouselColor: '#ED6A6D',
  testimonies: testimoniesEnglish,
  title: 'Veja o que nossos alunos estão dizendo da Fluencypass',
  testimonyConfig: {
    quoteColor: '#ED6A6D',
    wrapperColor: '#FDF0F0',
  },
};
